import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { isDebugBuild } from '#config/shared';
import { getTokenizedBackend } from '#config/renderer';
import { version } from '#config/definitions';
import EmbeddedModal from '#components/Elements/EmbeddedModal/EmbeddedModal';
import AppSettings from '../AppSettings/AppSettings.js';
import styles from './AppVersion.scss';

const AppVersion = () => {
  const backend = getTokenizedBackend();

  if (isDebugBuild && backend) {
    return (
      <EmbeddedModal
        trigger={({ open }) => (
          <button
            className={classNames(
              styles.version,
              styles.configure,
              styles[backend],
            )}
            onClick={open}
          >
            <FormattedMessage
              defaultMessage="Version {version} {backend}"
              description="App version on log-in screen (as debug config button)"
              values={{ version, backend }}
            />
          </button>
        )}
        content={({ close }) => <AppSettings onCloseModal={close} />}
      />
    );
  }

  return (
    <div className={styles.version}>
      <FormattedMessage
        defaultMessage="Version {version}"
        description="App version on log-in screen"
        values={{ version }}
      />
    </div>
  );
};

export default AppVersion;
